import { sentenceCase } from "@utils/common";
import Image from "next/image";
import React, { useState } from "react";
import { GoArrowLeft } from "react-icons/go";
import { HiOutlineDotsVertical } from "react-icons/hi";
export interface ContentItem {
    heading: string;
    paragraphs: string;
}
export interface TemplateGridProps {
    contents: ContentItem[];
}
const TemplatesGrid: React.FC<TemplateGridProps> = ({ contents }) => {
    const [clipboardText, setClipboardText] = useState<string[]>(Array(contents.length).fill("Copy"));

    const copyTemplate = (item: ContentItem, index: number) => {
        const formattedText = `${item.paragraphs}`;
        navigator.clipboard
            .writeText(formattedText)
            .then(() => {
                console.log("Message copied with WhatsApp Markdown!");
                const newClipboardText = Array(contents.length).fill("Copy");
                newClipboardText[index] = "Copied!";
                setClipboardText(newClipboardText);
                setTimeout(() => {
                    newClipboardText[index] = "Copy";
                    setClipboardText(newClipboardText);
                }, 2000);
            })
            .catch((err) => {
                console.error("Error copying text: ", err);
            });
    };

    const shareToWhatsapp = (item: ContentItem) => {
        const encodedMessage = encodeURIComponent(item.paragraphs);
        const shareLink = `https://api.whatsapp.com/send?text=${encodedMessage}`;
        window.open(shareLink, "_blank");
    };

    return (
        <div className="max-w-6xl mx-auto flex flex-col justify-between items-center gap-8 lg:gap-14">
            <div className=" flex flex-col items-center lg:mx-48 gap-4 mt-12">
                <h2 className="text-4xl text-gray-900 font-semibold text-center w-fit">Creative sparks: Ideas and examples to get you going</h2>
                <p className="text-base font-normal text-center mx-4 px-2 text-gray-700">Simply copy-paste or tweak them to suit your business needs to send it to your users</p>
            </div>
            <div className="flex flex-wrap items-start justify-center mb-10 gap-4">
                {contents.map((item, idx) => {
                    return (
                        <div key={idx} className="p-6 rounded-2xl border-8 bg-gray-100 border-gray-200  text-white" style={{ width: "372px", height: "530px" }}>
                            <div className="relative">
                                <p
                                    className="font-semibold text-gray-700 text-xl mb-2 truncate overflow-hidden whitespace-nowrap hover:overflow-visible hover:whitespace-normal"
                                    title={item.heading}
                                >
                                    {sentenceCase(item.heading)}
                                </p>
                            </div>
                            <div className="p-4 flex items-center justify-between rounded-t-xl" style={{ backgroundColor: "#008069" }}>
                                <div className="flex items-center gap-2 ">
                                    <GoArrowLeft size="30px" />
                                    <div className="bg-white w-12 h-12 flex items-center justify-center rounded-full">
                                        <Image width={26} height={26} src="/gallabox-icon.png" alt="gallabox icon" />
                                    </div>
                                    <div>
                                        <div className="flex items-center gap-1">
                                            <p className="text-base font-bold overflow-hidden truncate" style={{ maxWidth: "175px" }}>
                                                Gallabox
                                            </p>
                                            <Image
                                                src="https://assets.gallabox.com/gb-home/home-page/testimony/verified-green-tick.png"
                                                alt="Verified green tick"
                                                width={17}
                                                height={17}
                                                loading="lazy"
                                            />
                                        </div>
                                        <p className="text-base font-normal">Business Account</p>
                                    </div>
                                </div>
                                <div className="flex items-center gap-2">
                                    <div style={{ width: "22px", height: "17px" }}>
                                        <Image width={22} height={17} src="/ai-whatsapp-template-generator/Form/preview/market-store-icon.png" alt="Marketplace" />
                                    </div>
                                    <HiOutlineDotsVertical size="22px" />
                                </div>
                            </div>

                            <div
                                className="p-4"
                                style={{
                                    backgroundImage: "url(https://assets.gallabox.com/gb-home/ai-whatsapp-template-generator/form-preview/wa-background.png)",
                                    height: "300px",
                                    overflowY: "auto",
                                }}
                            >
                                <div className="relative sidevector bg-white rounded-xl shadow-lg text-sm font-normal text-gray-700 p-4">
                                    <p className="whitespace-pre-line">{item.paragraphs}</p>
                                    {/* eslint-disable-next-line react/no-unescaped-entities */}
                                    <p className="mt-2 text-xs font-normal text-gray-400">"Reply with 'STOP' to unsubscribe from marketing messages."</p>
                                </div>
                            </div>
                            <div
                                className="py-4 flex justify-center gap-2 rounded-b-xl"
                                style={{
                                    backgroundImage: "url(https://assets.gallabox.com/gb-home/ai-whatsapp-template-generator/form-preview/wa-background.png)",
                                }}
                            >
                                <button
                                    className="flex  gap-2 py-2 px-4 text-base font-medium text-white bg-green-400 border border-solid border-green-500 rounded-lg hover:shadow-md hover:bg-green-500 focus:outline-none"
                                    onClick={() => copyTemplate(item, idx)}
                                    data-cy={`usecase-template-copy-${idx}`}
                                >
                                    <Image src="https://assets.gallabox.com/gb-home/programmatic_seo/copy-logo.svg" alt={"logo"} width={24} height={24} />
                                    {clipboardText[idx]}
                                </button>
                                <button
                                    className="flex gap-2 py-2 px-4 text-base font-medium text-white bg-gray-600 border border-solid border-gray-400 rounded-lg hover:shadow-md hover:bg-gray-700 focus:outline-none"
                                    onClick={() => shareToWhatsapp(item)}
                                    data-cy={`usecase-template-share-${idx}`}
                                >
                                    <Image src="https://assets.gallabox.com/gb-home/programmatic_seo/whatsapp-logo.svg" alt={"logo"} width={24} height={24} />
                                    Share
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default TemplatesGrid;
